<template>
  <div class="min-h-screen bg-[#F7F7F7] text-white flex flex-col items-center px-4 py-10 relative mt-12">
    <div v-if="images.length > 0 || video" class="w-full max-w-6xl p-6 rounded-lg shadow-lg relative">
      <div class="flex flex-col md:flex-row items-center md:items-start">
        <div class="w-full md:w-1/2 md:pl-6 text-center md:text-left mt-4 md:mt-0">
          <h1 class="text-3xl font-bold mb-3 relative text-[#2E2E2E]">
            {{ folderTitle.en }}
            <span class="absolute -bottom-2 left-0 w-16 h-1 bg-[#E67E22]"></span>
          </h1>
          <div class="text-lg text-[#2E2E2E] mt-12 leading-relaxed" v-html="folderDescription.en"></div>
        </div>
        <div class="w-full md:w-1/2 relative ml-2">
          <div v-if="video" class="w-full">
            <video class="w-full h-auto rounded-lg shadow-lg" controls autoplay loop>
              <source :src="videoSrc" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>
          <div v-else-if="images.length > 0" class="w-full">
            <img
                :src="images[0].src"
                :alt="images[0].alt"
                class="w-full h-auto rounded-lg shadow-lg cursor-pointer"
                @click="openModal(images[0].src)"
                @error="handleImageError(images[0])"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="images.length > 0" class="flex flex-wrap justify-center items-center gap-4 mt-6">
      <div
          v-for="(image, index) in images"
          :key="index"
          class=" shadow-lg overflow-hidden transition-all hover:scale-105 text-[#2E2E2E]"
      >
        <img
            :src="image.src"
            :alt="image.alt"
            class="max-h-40 object-contain cursor-pointer transition-all hover:opacity-80"
            @click="openModal(image.src)"
            @error="handleImageError(image)"
        />
      </div>
    </div>

    <div v-else>
      <p class="text-center text-lg font-medium text-gray-300 mt-6">Loading content...</p>
    </div>

    <!-- Modal -->
    <div v-if="isModalOpen" class="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50">
      <button @click="closeModal" class="absolute top-4 right-4 text-white px-3 py-2 text-3xl z-50">&times;</button>

      <!-- Left arrow -->
      <button
          @click="prevImage"
          class="absolute left-4 text-white text-4xl z-50 px-3 py-1 hover:scale-110 transition"
          aria-label="Previous image"
      >
        ‹
      </button>

      <!-- Image -->
      <div class="relative">
        <img :src="images[currentImageIndex].src" class="max-w-full max-h-screen" />
      </div>

      <!-- Right arrow -->
      <button
          @click="nextImage"
          class="absolute right-4 text-white text-4xl z-50 px-3 py-1 hover:scale-110 transition"
          aria-label="Next image"
      >
        ›
      </button>
    </div>
  </div>
</template>

<script>
import { galleryFolders } from '@/data/GalleryPage/text.ts';

export default {
  data() {
    return {
      folderName: "",
      folderTitle: "",
      folderDescription: "",
      images: [],
      video: '',
      videoSrc: "",
      isModalOpen: false,
      modalImage: "",
      currentImageIndex: 0,
    };
  },
  created() {
    this.loadGalleryContent();
  },
  methods: {
    loadGalleryContent() {
      this.folderName = this.$route.params.id;

      const folderData = Object.values(galleryFolders).find(
          value => value.link === this.folderName
      );

      const isEnglish = location.hostname.startsWith('en.');

      if (folderData) {
        this.folderTitle = isEnglish && folderData.descriptionTitleEN
            ? folderData.descriptionTitleEN
            : folderData.descriptionTitle || "No title";

        this.folderDescription = isEnglish && folderData.descriptionEN
            ? folderData.descriptionEN
            : folderData.description || "";

        this.images = Array.from(
            {length: folderData.imageCount || 0},
            (_, index) => ({
              src: `/images/gallery/${folderData.title.pl}/image${index + 1}.jpeg`,
              alt: `${this.folderTitle} - Image ${index + 1}`,
              fallback: `/images/gallery/${folderData.title.pl}/image${index + 1}.jpg`,
              caption: folderData.captions ? folderData.captions[index] || "" : ""
            })
        );

        this.video = folderData.video;

        if (this.video) {
          this.videoSrc = `/images/gallery/${folderData.title}/video1.mp4`;
        }
      } else {
        console.warn("No folder found for link:", this.folderName);
      }
    },
    handleImageError(image) {
      if (image.src !== image.fallback) {
        image.src = image.fallback;
      }
    },
    openModal(imageSrc) {
      const foundIndex = this.images.findIndex(img => img.src === imageSrc);
      this.currentImageIndex = foundIndex !== -1 ? foundIndex : 0;
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.modalImage = "";
    },
    nextImage() {
      this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;
    },
    prevImage() {
      this.currentImageIndex =
          (this.currentImageIndex - 1 + this.images.length) % this.images.length;
    },
  }
};
</script>

<style scoped>
video, img {
  max-width: 100%;
  height: auto;
}
</style>
